import React from 'react'
import { SvgIcon } from '../svg-icon'

const defaultProps = {
    width: 16,
    height: 16
}

/**
 * Renders a distance icon
 * @see SvgIcon for propTypes
 *
 * @example
 * <DistanceIcon width={12} />
 */
const DistanceIcon = props => (
    <SvgIcon viewBoxSize={48} {...props}>
        <g id="icons">
            <path
                d={`M39,17V13H13V39h4l-7,6L3,39H7V9A2,2,0,0,1,9,7H39V3l6,6.86ZM27,41a2,2,0,1,0,2,2A2
                ,2,0,0,0,27,41Zm16,0a2,2,0,1,0,2,2A2,2,0,0,0,43,41Zm-8,0a2,2,0,1,0,2,2A2,2,0,0,0,35,
                41Zm8-8a2,2,0,1,0,2,2A2,2,0,0,0,43,33Zm0-8a2,2,0,1,0,2,2A2,2,0,0,0,43,25Z`}
            />
        </g>
    </SvgIcon>
)

DistanceIcon.defaultProps = defaultProps

export { DistanceIcon }
